import NavBar from "@/components/site/NavBar";
import Hero from "@/components/site/Hero";
import Marquee from "@/components/site/Marquee";
import Services from "@/components/site/Services";
import Pricing from "@/components/site/Pricing";
import Testimonials from "@/components/site/Testimonials";
import ReviewCTA from "@/components/site/ReviewCTA";
import ServiceArea from "@/components/site/ServiceArea";
import FAQ from "@/components/site/FAQ";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import StickyCallButton from "@/components/site/StickyCallButton";
import useSEO from "@/hooks/useSEO";
import { LOCAL_BUSINESS_JSONLD, HOME_FAQ_JSONLD, SITE_URL } from "@/data/structuredData";

const LandingPage = () => {
  useSEO({
    title: "Blue Collar World Pest Control · Pittsburgh PA · Licensed & Insured",
    description: "Pittsburgh's licensed & insured pest control experts. Termite treatment, bed bug removal, wildlife control, mosquito services for homes, parks & schools in Allegheny County. Se habla español. Free inspections. Call 484-764-3392.",
    canonical: `${SITE_URL}/`,
    jsonLd: [LOCAL_BUSINESS_JSONLD, HOME_FAQ_JSONLD],
  });
  return (
    <div className="bg-[#F4F4F5] text-zinc-900 min-h-screen">
      <NavBar />
      <main>
        <Hero />
        <Marquee />
        <Services />
        <Pricing />
        <Testimonials />
        <ReviewCTA />
        <ServiceArea />
        <FAQ />
        <Contact />
      </main>
      <Footer />
      <StickyCallButton />
    </div>
  );
};

export default LandingPage;
